import fetchManager from '@utils/fetchManager'
import { getEnvironment, urlQueryData } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

// const API_URL = 'http://localhost:8085'

export default {
  getTransactionName: async () => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/transactionName`)
    return response
  },
  sendActionToBitacora: async (data) => {
    const errorModal = { show: 'no' }
    
    const response = await fetchManager(`${API_URL}/GraylogManagement/api/amx/cpe/comment`, {
      method: 'POST',
      data,
    }, errorModal)
    return response
  },
  getSearchBitacora: async (querys) => {
    const url = urlQueryData(`${API_URL}/GraylogManagement/api/amx/cpe/search/absolute`, querys)

    const response = await fetchManager(url)
    return response
  }
}
